import * as React from 'react';

import {Divider} from '../layout/divider';
import {Stack} from '../layout/stack/stack';
import {Body} from '../typography/body';

import styles from './connection-info-description.module.css';

type DescriptionItem = {
    icon: React.ReactElement<any>;
    text: string;
};

type Props = {
    items: DescriptionItem[];
};

export function ConnectionInfoDescription(props: Props) {
    return (
        <div className={styles.container}>
            <Stack spacing={16}>
                {props.items.map((item, index) => (
                    <React.Fragment key={item.text}>
                        {index > 0 && <Divider variant='line--horizontal' spacing={0} />}
                        {/* @ts-expect-error */}
                        <Stack spacing={12} alignCenter={true} isHorizontal={true}>
                            {item.icon}
                            <Body size='small' color='light'>
                                {item.text}
                            </Body>
                        </Stack>
                    </React.Fragment>
                ))}
            </Stack>
        </div>
    );
}
